import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/store/clusterdev/manglish-desh-web/app/(routes)/apk/components/Footer/index.tsx");
;
import(/* webpackMode: "eager" */ "/mnt/store/clusterdev/manglish-desh-web/app/(routes)/apk/components/Header/style.module.css");
;
import(/* webpackMode: "eager" */ "/mnt/store/clusterdev/manglish-desh-web/app/(routes)/apk/components/Subfooter/style.module.css");
;
import(/* webpackMode: "eager" */ "/mnt/store/clusterdev/manglish-desh-web/app/(routes)/apk/style.module.css");
;
import(/* webpackMode: "eager" */ "/mnt/store/clusterdev/manglish-desh-web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/mnt/store/clusterdev/manglish-desh-web/node_modules/next/dist/client/link.js");
